export const forwards = `
<svg width="16px" height="16px" viewBox="0 -2 16 16" id="forward-16px" xmlns="http://www.w3.org/2000/svg">
  <path id="Path_100" data-name="Path 100" d="M34.962,5.691a.505.505,0,0,0,0-.382.518.518,0,0,0-.109-.163l-3-3a.5.5,0,1,0-.708.708L33.293,5H24.5A5.506,5.506,0,0,0,19,10.5v3a.5.5,0,0,0,1,0v-3A4.505,4.505,0,0,1,24.5,6h8.793L31.146,8.146a.5.5,0,0,0,.708.708l3-3A.518.518,0,0,0,34.962,5.691Z" transform="translate(-19 -2)"/>
</svg>
`;